export default "__VITE_ASSET__DbzZ4etu__"